export default __webpack_public_path__ + "fdd52b07f1c79c846227943d48f71c32.svg";